import { render, staticRenderFns } from "./Dictionary.vue?vue&type=template&id=4ca24376&scoped=true"
import script from "./Dictionary.vue?vue&type=script&lang=js"
export * from "./Dictionary.vue?vue&type=script&lang=js"
import style0 from "./Dictionary.vue?vue&type=style&index=0&id=4ca24376&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca24376",
  null
  
)

export default component.exports